<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
};
</script>
<template>
  <div class="about-section section-space--inner--80">
    <div class="container">
      <div class="row row-25 ">
        <div class="col-lg-2 col-12 mb-30" style="margin-top: 20px;">
          <div class="bg-home--pengantar"></div>
          <img
            v-if="data.image.length > 0"
            :src="data.image"
            alt="team
          member image"
            class="circular--landscape"
          />
          <img
            v-else
            src="@/assets/images/global/list_empty.png"
            alt="team
          member image"
            class="circular--landscape"
          />
          <!-- <div class="team">
                        <div class="image">
                            <img :src="data.sambutan.headMaster.image" alt="team member image" class="img-sambutan-home">
                        </div> -->
          <!-- <div class="content">
                            <h3 class="title">{{ data.sambutan.headMaster.name }}</h3>
                            <span>{{ data.sambutan.headMaster.designation }}</span>
                            <a href="mailto:info@example.com" class="email">{{ data.sambutan.headMaster.email }}</a>
                            <div class="social">
                                <a :href="item.link" :class="item.addClass" target="_blank" v-for="item in data.sambutan.headMaster.social" :key="item.id">
                                    <i :class="item.icon"></i>
                                </a>
                            </div>
                        </div> -->
          <!-- </div> -->
        </div>
        <div class="col-lg-1"></div>
        <div
          class="col-lg-9 col-12 mb-30"
          style="border: 1px solid #F4F4F4; padding: 20px;"
        >
          <div class="about-content-two">
            <h3 class="text-color-default">
              <span class="span-hr"> KATA PENGANTAR </span>
            </h3>
            <br /><br />
            <div v-html="data.body"></div>
            <!-- <h3>{{ data.sambutan.headMaster.name }}</h3>
                        <p>{{ data.sambutan.headMaster.designation }}</p>
                        <h1>{{ data.sambutan.title }}</h1>
                        <h4>{{ data.sambutan.shortDesc }}</h4>
                        <p>{{ data.sambutan.desc }}</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/6-responsive/template-blue/index.scss";
</style>
